<h1>
  {{'User Management' | translate}}
</h1>

<div class="menu-wrap" fxLayout fxLayoutAlign.xs="space-around">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>
  <a *ngIf="isUserAllowedToManageCustomers" class="box" [routerLink]="['/' + manageCustomersPath]">{{'Manage customers' | translate}}</a>
  <a *ngIf="isUserAllowedToManageUsers" class="box" [routerLink]="['/' + manageUsersPath]">{{'Manage all users' | translate}}</a>
  <a *ngIf="isUserAllowedToManageCompanyUsers" class="box" [routerLink]="['/' + manageCompanyUsersPath]">{{'Manage my company users' | translate}}</a>
  <a *ngIf="isUserAllowedToManageCompanyData" class="box" [routerLink]="['/' + manageCompanyDataPath]">{{'Change my company data' | translate}}</a>
</div>
